
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormDataService {
    constructor() { }
  
       public getCanadianProvinceCodes(){
        let provinces: Array<any> = [
          {
            name: "Alberta",
            code: "AB"
          },
          {
            name: "British Columbia",
            code: "BC"
          },
          {
            name: "Manitoba",
            code: "MB"
          },
          {
            name: "Newfoundland and Labrador",
            code: "NL"
          },
          {
            name: "New Brunswick",
            code: "NB"
          },
          {
            name: "Northwest Territories",
            code: "NT"
          },
          {
            name: "Nova Scotia",
            code: "NS"
          },
          {
            name: "Nunavut",
            code: "NU"
          },
          {
            name: "Ontario",
            code: "ON"
          },
          {
            name: "Prince Edward Island",
            code: "PE"
          },
          {
            name: "Quebec",
            code: "QC"
          },
          {
            name: "Saskatchewan",
            code: "SK"
          },
          {
            name: "Yukon",
            code: "YT"
          }
        ];
    
        return provinces;
      }
    public getUSStateCodes(){
      let usaStatesList = [
        {value:"AK",label:"ALASKA"}, 
        {value:"AL",label:"ALABAMA"}, 
        {value:"AR",label:"ARKANSAS"}, 
        {value:"AS",label:"American Samoa"}, 
        {value:"AZ",label:"ARIZONA"}, 
        {value:"CA",label:"CALIFORNIA"}, 
        {value:"CO",label:"COLORADO"}, 
        {value:"CT",label:"CONNECTICUT"}, 
        {value:"DC",label:"DISTRICT OF COLUMBIA"}, 
        {value:"DE",label:"DELAWARE"}, 
        {value:"FL",label:"Florida"}, 
        {value:"FM",label:"Federated States of Micronesia"}, 
        {value:"GA",label:"GEORGIA"}, 
        {value:"GU",label:"Guam"}, 
        {value:"HI",label:"HAWAII"}, 
        {value:"IA",label:"IOWA"}, 
        {value:"ID",label:"IDAHO"}, 
        {value:"IL",label:"ILLINOIS"}, 
        {value:"IN",label:"INDIANA"}, 
        {value:"KS",label:"KANSAS"}, 
        {value:"KY",label:"KENTUCKY"}, 
        {value:"LA",label:"LOUISIANA"}, 
        {value:"MA",label:"MASSACHUSETTS"}, 
        {value:"MD",label:"MARYLAND"}, 
        {value:"ME",label:"MAINE"}, 
        {value:"MH",label:"Marshall Islands"}, 
        {value:"MI",label:"MICHIGAN"}, 
        {value:"MN",label:"MINNESOTA"}, 
        {value:"MO",label:"MISSOURI"}, 
        {value:"MP",label:"Northern Mariana Islands"}, 
        {value:"MS",label:"MISSISSIPPI"}, 
        {value:"MT",label:"MONTANA"}, 
        {value:"NC",label:"NORTH CAROLINA"}, 
        {value:"ND",label:"NORTH DAKOTA"}, 
        {value:"NE",label:"NEBRASKA"}, 
        {value:"NH",label:"NEW HAMPSHIRE"}, 
        {value:"NJ",label:"NEW JERSEY"}, 
        {value:"NM",label:"NEW MEXICO"}, 
        {value:"NV",label:"NEVADA"}, 
        {value:"NY",label:"NEW YORK"}, 
        {value:"OH",label:"OHIO"}, 
        {value:"OK",label:"OKLAHOMA"}, 
        {value:"OR",label:"OREGON"}, 
        {value:"PA",label:"PENNSYLVANIA"}, 
        {value:"PR",label:"Puerto Rico"}, 
        {value:"PW",label:"Palau"}, 
        {value:"RI",label:"RHODE ISLAND"}, 
        {value:"SC",label:"SOUTH CAROLINA"}, 
        {value:"SD",label:"SOUTH DAKOTA"}, 
        {value:"TN",label:"TENNESSEE"}, 
        {value:"TX",label:"TEXAS"}, 
        {value:"UT",label:"UTAH"}, 
        {value:"VA",label:"VIRGINIA"}, 
        {value:"VI",label:"Virgin Islands"}, 
        {value:"VT",label:"VERMONT"}, 
        {value:"WA",label:"WASHINGTON"}, 
        {value:"WI",label:"WISCONSIN"}, 
        {value:"WV",label:"WEST VIRGINIA"}, 
        {value:"WY",label:"WYOMING"}]
      return usaStatesList;
    }

    getCountryCodes(){
      let countryCodes=[
        {value:"AD",label:"Andorra"}, 
        {value:"AE",label:"United Arab Emirates"}, 
        {value:"AF",label:"Afghanistan"}, 
        {value:"AG",label:"Antigua and Barbuda"}, 
        {value:"AI",label:"Anguilla"}, 
        {value:"AL",label:"Albania"}, 
        {value:"AM",label:"Armenia"}, 
        {value:"AN",label:"Netherlands Antilles"}, 
        {value:"AO",label:"Angola"}, 
        {value:"AQ",label:"Antarctica"}, 
        {value:"AR",label:"Argentina"}, 
        {value:"AS",label:"American Samoa"}, 
        {value:"AT",label:"Austria"}, 
        {value:"AU",label:"Australia"}, 
        {value:"AW",label:"Aruba"}, 
        {value:"AX",label:"Aland Islands"}, 
        {value:"AZ",label:"Azerbaijan"}, 
        {value:"BA",label:"Bosnia and Herzegovina"}, 
        {value:"BB",label:"Barbados"}, 
        {value:"BD",label:"Bangladesh"}, 
        {value:"BE",label:"Belgium"}, 
        {value:"BF",label:"Burkina Faso"}, 
        {value:"BG",label:"Bulgaria"}, 
        {value:"BH",label:"Bahrain"}, 
        {value:"BI",label:"Burundi"}, 
        {value:"BJ",label:"Benin"}, 
        {value:"BL",label:"Saint-Barthélemy"}, 
        {value:"BM",label:"Bermuda"}, 
        {value:"BN",label:"Brunei Darussalam"}, 
        {value:"BO",label:"Bolivia"}, 
        {value:"BR",label:"Brazil"}, 
        {value:"BS",label:"Bahamas"}, 
        {value:"BT",label:"Bhutan"}, 
        {value:"BV",label:"Bouvet Island"}, 
        {value:"BW",label:"Botswana"}, 
        {value:"BY",label:"Belarus"}, 
        {value:"BZ",label:"Belize"}, 
        {value:"CA",label:"Canada"}, 
        {value:"CC",label:"Cocos (Keeling) Islands"}, 
        {value:"CD",label:"Congo, (Kinshasa)"}, 
        {value:"CF",label:"Central African Republic"}, 
        {value:"CG",label:"Congo (Brazzaville)"}, 
        {value:"CH",label:"Switzerland"}, 
        {value:"CI",label:"Côte d'Ivoire"}, 
        {value:"CK",label:"Cook Islands"}, 
        {value:"CL",label:"Chile"}, 
        {value:"CM",label:"Cameroon"}, 
        {value:"CN",label:"China"}, 
        {value:"CO",label:"Colombia"}, 
        {value:"CR",label:"Costa Rica"}, 
        {value:"CS",label:"Serbia and Montenegro"}, 
        {value:"CU",label:"Cuba"}, 
        {value:"CV",label:"Cape Verde"}, 
        {value:"CX",label:"Christmas Island"}, 
        {value:"CY",label:"Cyprus"}, 
        {value:"CZ",label:"Czech Republic"}, 
        {value:"DE",label:"Germany"}, 
        {value:"DJ",label:"Djibouti"}, 
        {value:"DK",label:"Denmark"}, 
        {value:"DM",label:"Dominica"}, 
        {value:"DO",label:"Dominican Republic"}, 
        {value:"DZ",label:"Algeria"}, 
        {value:"EC",label:"Ecuador"}, 
        {value:"EE",label:"Estonia"}, 
        {value:"EG",label:"Egypt"}, 
        {value:"EH",label:"Western Sahara"}, 
        {value:"ER",label:"Eritrea"}, 
        {value:"ES",label:"Spain"}, 
        {value:"ET",label:"Ethiopia"}, 
        {value:"FI",label:"Finland"}, 
        {value:"FJ",label:"Fiji"}, 
        {value:"FK",label:"Falkland Islands (Malvinas)"}, 
        {value:"FM",label:"Micronesia, Federated States of"}, 
        {value:"FO",label:"Faroe Islands"}, 
        {value:"FR",label:"France"}, 
        {value:"GA",label:"Gabon"}, 
        {value:"GB",label:"United Kingdom"}, 
        {value:"GD",label:"Grenada"}, 
        {value:"GE",label:"Georgia"}, 
        {value:"GF",label:"French Guiana"}, 
        {value:"GG",label:"Guernsey"}, 
        {value:"GH",label:"Ghana"}, 
        {value:"GI",label:"Gibraltar"}, 
        {value:"GL",label:"Greenland"}, 
        {value:"GM",label:"Gambia"}, 
        {value:"GN",label:"Guinea"}, 
        {value:"GP",label:"Guadeloupe"}, 
        {value:"GQ",label:"Equatorial Guinea"}, 
        {value:"GR",label:"Greece"}, 
        {value:"GS",label:"South Georgia and the South Sandwich Islands"}, 
        {value:"GT",label:"Guatemala"}, 
        {value:"GU",label:"Guam"}, 
        {value:"GW",label:"Guinea-Bissau"}, 
        {value:"GY",label:"Guyana"}, 
        {value:"HK",label:"Hong Kong, SAR China"}, 
        {value:"HM",label:"Heard and Mcdonald Islands"}, 
        {value:"HN",label:"Honduras"}, 
        {value:"HR",label:"Croatia"}, 
        {value:"HT",label:"Haiti"}, 
        {value:"HU",label:"Hungary"}, 
        {value:"ID",label:"Indonesia"}, 
        {value:"IE",label:"Ireland"}, 
        {value:"IL",label:"Israel"}, 
        {value:"IM",label:"Isle of Man"}, 
        {value:"IN",label:"India"}, 
        {value:"IO",label:"British Indian Ocean Territory"}, 
        {value:"IQ",label:"Iraq"}, 
        {value:"IR",label:"Iran, Islamic Republic of"}, 
        {value:"IS",label:"Iceland"}, 
        {value:"IT",label:"Italy"}, 
        {value:"JE",label:"Jersey"}, 
        {value:"JM",label:"Jamaica"}, 
        {value:"JO",label:"Jordan"}, 
        {value:"JP",label:"Japan"}, 
        {value:"KE",label:"Kenya"}, 
        {value:"KG",label:"Kyrgyzstan"}, 
        {value:"KH",label:"Cambodia"}, 
        {value:"KI",label:"Kiribati"}, 
        {value:"KM",label:"Comoros"}, 
        {value:"KN",label:"Saint Kitts and Nevis"}, 
        {value:"KP",label:"Korea (North)"}, 
        {value:"KR",label:"Korea (South)"}, 
        {value:"KW",label:"Kuwait"}, 
        {value:"KY",label:"Cayman Islands"}, 
        {value:"KZ",label:"Kazakhstan"}, 
        {value:"LA",label:"Lao PDR"}, 
        {value:"LB",label:"Lebanon"}, 
        {value:"LC",label:"Saint Lucia"}, 
        {value:"LI",label:"Liechtenstein"}, 
        {value:"LK",label:"Sri Lanka"}, 
        {value:"LR",label:"Liberia"}, 
        {value:"LS",label:"Lesotho"}, 
        {value:"LT",label:"Lithuania"}, 
        {value:"LU",label:"Luxembourg"}, 
        {value:"LV",label:"Latvia"}, 
        {value:"LY",label:"Libya"}, 
        {value:"MA",label:"Morocco"}, 
        {value:"MC",label:"Monaco"}, 
        {value:"MD",label:"Moldova"}, 
        {value:"ME",label:"Montenegro"}, 
        {value:"MF",label:"Saint-Martin (French part)"}, 
        {value:"MG",label:"Madagascar"}, 
        {value:"MH",label:"Marshall Islands"}, 
        {value:"MK",label:"Macedonia, Republic of"}, 
        {value:"ML",label:"Mali"}, 
        {value:"MM",label:"Myanmar"}, 
        {value:"MN",label:"Mongolia"}, 
        {value:"MO",label:"Macao, SAR China"}, 
        {value:"MP",label:"Northern Mariana Islands"}, 
        {value:"MQ",label:"Martinique"}, 
        {value:"MR",label:"Mauritania"}, 
        {value:"MS",label:"Montserrat"}, 
        {value:"MT",label:"Malta"}, 
        {value:"MU",label:"Mauritius"}, 
        {value:"MV",label:"Maldives"}, 
        {value:"MW",label:"Malawi"}, 
        {value:"MX",label:"Mexico"}, 
        {value:"MY",label:"Malaysia"}, 
        {value:"MZ",label:"Mozambique"}, 
        {value:"NA",label:"Namibia"}, 
        {value:"NC",label:"New Caledonia"}, 
        {value:"NE",label:"Niger"}, 
        {value:"NF",label:"Norfolk Island"}, 
        {value:"NG",label:"Nigeria"}, 
        {value:"NI",label:"Nicaragua"}, 
        {value:"NL",label:"Netherlands"}, 
        {value:"NO",label:"Norway"}, 
        {value:"NP",label:"Nepal"}, 
        {value:"NR",label:"Nauru"}, 
        {value:"NU",label:"Niue"}, 
        {value:"NZ",label:"New Zealand"}, 
        {value:"OM",label:"Oman"}, 
        {value:"PA",label:"Panama"}, 
        {value:"PE",label:"Peru"}, 
        {value:"PF",label:"French Polynesia"}, 
        {value:"PG",label:"Papua New Guinea"}, 
        {value:"PH",label:"Philippines"}, 
        {value:"PK",label:"Pakistan"}, 
        {value:"PL",label:"Poland"}, 
        {value:"PM",label:"Saint Pierre and Miquelon"}, 
        {value:"PN",label:"Pitcairn"}, 
        {value:"PR",label:"Puerto Rico"}, 
        {value:"PS",label:"Palestinian Territory"}, 
        {value:"PT",label:"Portugal"}, 
        {value:"PW",label:"Palau"}, 
        {value:"PY",label:"Paraguay"}, 
        {value:"QA",label:"Qatar"}, 
        {value:"RE",label:"Réunion"}, 
        {value:"RO",label:"Romania"}, 
        {value:"RS",label:"Serbia"}, 
        {value:"RU",label:"Russian Federation"}, 
        {value:"RW",label:"Rwanda"}, 
        {value:"SA",label:"Saudi Arabia"}, 
        {value:"SB",label:"Solomon Islands"}, 
        {value:"SC",label:"Seychelles"}, 
        {value:"SD",label:"Sudan"}, 
        {value:"SE",label:"Sweden"}, 
        {value:"SG",label:"Singapore"}, 
        {value:"SH",label:"Saint Helena"}, 
        {value:"SI",label:"Slovenia"}, 
        {value:"SJ",label:"Svalbard and Jan Mayen Islands"}, 
        {value:"SK",label:"Slovakia"}, 
        {value:"SL",label:"Sierra Leone"}, 
        {value:"SM",label:"San Marino"}, 
        {value:"SN",label:"Senegal"}, 
        {value:"SO",label:"Somalia"}, 
        {value:"SR",label:"Suriname"}, 
        {value:"SS",label:"South Sudan"}, 
        {value:"ST",label:"Sao Tome and Principe"}, 
        {value:"SV",label:"El Salvador"}, 
        {value:"SY",label:"Syrian Arab Republic (Syria)"}, 
        {value:"SZ",label:"Swaziland"}, 
        {value:"TC",label:"Turks and Caicos Islands"}, 
        {value:"TD",label:"Chad"}, 
        {value:"TF",label:"French Southern Territories"}, 
        {value:"TG",label:"Togo"}, 
        {value:"TH",label:"Thailand"}, 
        {value:"TJ",label:"Tajikistan"}, 
        {value:"TK",label:"Tokelau"}, 
        {value:"TL",label:"Timor-Leste"}, 
        {value:"TM",label:"Turkmenistan"}, 
        {value:"TN",label:"Tunisia"}, 
        {value:"TO",label:"Tonga"}, 
        {value:"TR",label:"Turkey"}, 
        {value:"TT",label:"Trinidad and Tobago"}, 
        {value:"TV",label:"Tuvalu"}, 
        {value:"TW",label:"Taiwan, Republic of China"}, 
        {value:"TZ",label:"Tanzania, United Republic of"}, 
        {value:"UA",label:"Ukraine"}, 
        {value:"UG",label:"Uganda"}, 
        {value:"UM",label:"US Minor Outlying Islands"}, 
        {value:"US",label:"United States of America"}, 
        {value:"UY",label:"Uruguay"}, 
        {value:"UZ",label:"Uzbekistan"}, 
        {value:"VA",label:"Holy See (Vatican City State)"}, 
        {value:"VC",label:"Saint Vincent and Grenadines"}, 
        {value:"VE",label:"Venezuela (Bolivarian Republic)"}, 
        {value:"VG",label:"British Virgin Islands"}, 
        {value:"VI",label:"Virgin Islands, US"}, 
        {value:"VN",label:"Viet Nam"}, 
        {value:"VU",label:"Vanuatu"}, 
        {value:"WF",label:"Wallis and Futuna Islands"}, 
        {value:"WS",label:"Samoa"}, 
        {value:"YE",label:"Yemen"}, 
        {value:"YT",label:"Mayotte"}, 
        {value:"ZA",label:"South Africa"}, 
        {value:"ZM",label:"Zambia"}, 
        {value:"ZW",label:"Zimbabwe"}]
      return countryCodes;
    }
}